export default __webpack_public_path__ + "tint-drop.png";